/**
 * Маппинг start_param из Telegram на роуты приложения
 * Поддерживает регистронезависимое сравнение
 */

/**
 * Преобразует start_param в роут приложения
 * @param {string} startParam - параметр из Telegram WebApp
 * @returns {string|null} - путь роута или null если параметр невалидный
 */
export const getRouteFromStartParam = (startParam) => {
  if (!startParam || typeof startParam !== 'string') {
    return null
  }

  const param = startParam.toLowerCase()

  // Прямые ссылки на страницы
  // Например https://t.me/SkinozBot/app?startapp=Referrals
  const directRoutes = {
    'referrals': '/referrals',
    'cases': '/cases',
    'double': '/double',
    'inventory': '/inventory',
    'profile': '/profile',
    'upgrader': '/upgrader',
    'contract': '/contract',
    'payment': '/payment',
    'transactions': '/transactions',
    'games': '/games',
    'event': '/event',
    'market': '/market',
    'playground': '/playground',
    'battles': '/battles',
    'royale': '/royale'
  }

  // Проверяем прямые роуты
  if (directRoutes[param]) {
    return directRoutes[param]
  }

  // Проверяем ссылку на конкретный кейс
  // Формат: case_ID или просто ID кейса
  if (param.startsWith('case_')) {
    const caseId = param.replace('case_', '')
    return `/cases/${caseId}`
  }

  // Если параметр выглядит как ID кейса (длинная строка без пробелов)
  // Пробуем интерпретировать как прямую ссылку на кейс
  if (param.length > 20 && !param.includes(' ')) {
    return `/cases/${startParam}` // Используем оригинальный регистр для ID
  }

  return null
}

/**
 * Извлекает start_param из Telegram WebApp
 * @returns {string|null} - значение start_param или null
 */
export const getTelegramStartParam = () => {
  try {
    // Проверяем наличие Telegram WebApp API
    if (!window.Telegram?.WebApp) {
      return null
    }

    // Получаем start_param из initDataUnsafe
    const startParam = window.Telegram.WebApp.initDataUnsafe?.start_param

    if (startParam && typeof startParam === 'string') {
      return startParam
    }

    // Fallback: проверяем GET параметр tgWebAppStartParam
    const urlParams = new URLSearchParams(window.location.search)
    const urlStartParam = urlParams.get('tgWebAppStartParam')

    return urlStartParam || null
  } catch (error) {
    console.error('[StartParam] Error extracting start_param:', error)
    return null
  }
}
